module.exports = __webpack_public_path__ + "static/media/bg-reports.a29f1d8c.jpg";